import mark from './mark';

/**
 * Marks the baseline for route changes.
 */
export default (): PerformanceMark | void => mark('baseline');
